import { ReactComponent as MagnifyingGlassSVG } from 'assets/icons/magnifying-glass.svg'

import { IconStyles } from '../types'
import { MagnifyingGlass } from './styles'
import { HoverText } from './styles'

interface MagnifyingGlassProps extends IconStyles {
  onClick?: any
  filter?: boolean
  hoverText?: string;
}

const MagnifyingGlassIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  style,
  opacity,
  hoverText,
}: MagnifyingGlassProps) => {
  return (
    <MagnifyingGlass
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
      opacity={opacity}
      style={style}
    >
      <MagnifyingGlassSVG />
      {hoverText && <HoverText className="hover-text">{hoverText}</HoverText>}
    </MagnifyingGlass>
  )
}

export default MagnifyingGlassIcon
